import { useCallback } from 'react';
import { statsService } from '../services/statsService';
import { type LeaderboardUser, StatsLeaderboard } from './StatsLeaderboard';

export const ChatHistoryLeaderboard = () => {
    const fetchUsers = useCallback(async (): Promise<LeaderboardUser[]> => {
        const users = await statsService.getTopUsersByChatCount(20);
        return users.map((u) => ({
            userId: u.userId,
            email: u.email,
            displayName: u.displayName,
            value: u.normalChatCount + u.questChatCount,
            secondaryValue: `${u.normalChatCount} / ${u.questChatCount}`,
            memberSince: u.memberSince,
            lastUsedAt: u.lastUsedAt,
        }));
    }, []);

    return (
        <StatsLeaderboard
            title="Chat History Leaderboard"
            valueLabel="Chats"
            valueUnit="chats"
            secondaryValueLabel="Normal / Quest"
            emptyMessage="No users with saved chats found."
            fetchUsers={fetchUsers}
            showLastUsed
        />
    );
};
